module.exports = __webpack_public_path__ + "static/media/comment-outlined.99d716a9.svg";